import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-auto">
            <p>Special Restaurant &#169; Copyright 2021</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
